// extracted by mini-css-extract-plugin
export default {"contents":"UM-z","sectionHeading":"VM-z"};